import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import axios from 'axios'
import RoleControlled from '../../../_common/RoleControlled'

import { toggleVisibility, showToast } from '../../../../actions'
import { URL } from '../../../../const'

import GuideItem from './GuideItem'
import AddGuide from './AddGuide'
import Loader from '../../../_common/Loader'

export class Guide extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      category: {},
      data: [],
      addingNewGuide: false
    }
  }
  componentDidMount () {
    this._fetchData()
  }
  async _fetchData () {
    this.setState({ loading: true })
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const url = `${URL}guides/${this.props.propertyID}/${this.props.match.params.guide_id}`
    try {
      const res = await axios.get(
        url,
        config
      )
      const data = res.data.items
      const category = res.data.category
      this.setState({ data, category, loading: false })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }
  _handleAddClick () {
    console.log('add guide')
    this.setState({ addingNewGuide: true })
  }
  _handleCancelClick () {
    console.log('cancel')
    this.setState({ addingNewGuide: false })
  }
  _handleBackClick = () => {
    const propertyID = this.props.activeDetails.data.property_id
    this.props.history.push(`/properties/${propertyID}/guides`)
  }

  async _handleSaveGuide (data, image) {
    console.log('saving data...', data)
    const url = `${URL}guides/${this.props.propertyID}/${this.props.match.params.guide_id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      const imageExtension = image.name.split('.').pop()
      const imageName = `guide-property${this.props.propertyID || '000'}-${Date.now()}.${imageExtension}`

      console.log('image: ', image)
      console.log('imageName: ', imageName)
      formData.append('image', image, imageName)
    }
    console.log('data: ', JSON.stringify(data))
    try {
      const res = await axios.post(
        url,
        formData,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  async _handleCreateGuide (data, image) {
    console.log('saving data...', data)
    const url = `${URL}guides/${this.props.propertyID}/${this.props.match.params.guide_id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    const formData = new FormData()
    formData.append('data', JSON.stringify(data))
    if (image) {
      const imageExtension = image.name.split('.').pop()
      const imageName = `guide-property${this.props.propertyID || '000'}-${Date.now()}.${imageExtension}`

      console.log('image: ', image)
      console.log('imageName: ', imageName)
      formData.append('image', image, imageName)
    }
    console.log('data: ', JSON.stringify(data))
    try {
      const res = await axios.post(
        url,
        formData,
        config
      )
      console.log('post res: ', res)
      this.setState({ addingNewGuide: false })
      this.props.showToast('保存しました！', 'primary')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
      this.props.showToast('エラーが発生しました。', 'danger')
    }
  }
  async _handleDeleteGuide (id) {
    const url = `${URL}guides/?id=${id}`
    const config = {
      headers: {
        'Authorization': `Token ${this.props.user.token}`
      }
    }
    try {
      const res = await axios.delete(
        url,
        config
      )
      console.log('post res: ', res)
      this.props.showToast('削除しました。', 'danger')
      this._fetchData()
    } catch (error) {
      console.log('error: ', error)
    }
  }
  _renderMain () {
    return (
      <div className="inner_container">
        { this._renderAddItem() }
        { this._renderList() }
      </div>
    )
  }

  _renderAddItem () {
    if (this.state.addingNewGuide) {
      return (
        <AddGuide
          categoryID={this.state.category.guide_category_id}
          saveData={this._handleCreateGuide.bind(this)}
          cancel={this._handleCancelClick.bind(this)}
        />
      )
    }
    return null
  }

  _renderList () {
    return this.state.data.map(item => {
      return (
        <GuideItem
          categoryID={this.state.category.guide_category_id}
          guide={item}
          key={item.id}
          role={this.props.user.user_role}
          saveData={this._handleSaveGuide.bind(this)}
          deleteData={this._handleDeleteGuide.bind(this)}
        />
      )
    })
  }
  render () {
    if (this.props.activeDetails.data.owner_id === 1) { return null }
    return (
      this.state.loading
        ? <Loader classname="loader_dot_circle"/>
        : (
          <div>
            <div className="category_info flex">
              <div className="img_container">
                <img src={this.state.category.imageBase64} alt=""/>
              </div>
              <div className="category_name">{this.state.category.guide_category_name}</div>
            </div>
            <h4 className="page_title bold">各種ご案内詳細</h4>
            <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
              <div className="add_btn_container flex">
                <button className="btn primary small_btn flex align-center" onClick={this._handleAddClick.bind(this)}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                  <span>追加</span>
                </button>
              </div>
            </RoleControlled>

            <div className="list_container">
              { this._renderMain() }
            </div>
            <div className="back_btn flex justify-center">
              <button className="btn reverse_primary" onClick={this._handleBackClick}>カテゴリ一覧へ戻る</button>
            </div>
          </div>
        )
    )
  }
}

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default withRouter(connect(mapStateToProps, { toggleVisibility, showToast })(Guide))



// WEBPACK FOOTER //
// ./src/components/Properties/Guides/Guide/index.js